import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useSessionApi() {
  const { menuIdRef, userRef, languageRef } = useStorage();

  function refreshSessionFromRemote(id) {
    const url = `/vbeta2/sessions/${id}/refresh`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function setSessionDeliveryAddressFromRemote(id, data) {
    const url = `/vbeta2/sessions/${id}/set_delivery_address`;

    return axios({
      url,
      method: 'post',
      data,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    refreshSessionFromRemote,
    setSessionDeliveryAddressFromRemote,
  };
}

export { useSessionApi };
